import { apiClient } from './apiClient';

class AdminAPI {
  constructor() {
    this.adminURL = '/admin_users/';
  }

  indexUsers(type) {
    return apiClient.request(`${this.adminURL}${type}/`, 'GET', true);
  }

  getUser(type, id) {
    return apiClient.request(`${this.adminURL}${type}/${id}`, 'GET', true);
  }

  createUser(type, user) {
    return apiClient.request(
      `${this.adminURL}${type}s/`, // figure out something better on the API
      'POST',
      true,
      { [type]: user }
    );
  }

  updateUser(type, id, user) {
    return apiClient.request(`${this.adminURL}${type}s/${id}`, 'PUT', true, {
      [type]: user
    });
  }

  getDashboard() {
    return apiClient.request('/dashboard', 'GET', true);
  }
}
export const adminAPI = new AdminAPI();



// WEBPACK FOOTER //
// ./src/InterfaceAPI/adminAPI.js